import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const keyOf = (productId, size, design, pers) => `${productId}::${size || ""}::${design || ""}::${pers || ""}`;
const itemKey = (i) => keyOf(i.product.id, i.size, i.design, i.personalization);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("gobig_cart") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("gobig_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product, quantity = 1, size = null, design = null, personalization = null) => {
    setItems((prev) => {
      const item = { product, quantity, size, design, personalization };
      const k = itemKey(item);
      const found = prev.find((i) => itemKey(i) === k);
      if (found) {
        return prev.map((i) => (itemKey(i) === k ? { ...i, quantity: i.quantity + quantity } : i));
      }
      return [...prev, item];
    });
  };

  const updateQuantity = (item, quantity) => {
    if (quantity <= 0) return removeItem(item);
    const k = itemKey(item);
    setItems((prev) => prev.map((i) => (itemKey(i) === k ? { ...i, quantity } : i)));
  };

  const removeItem = (item) => {
    const k = itemKey(item);
    setItems((prev) => prev.filter((i) => itemKey(i) !== k));
  };

  const clearCart = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + i.product.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  const value = useMemo(
    () => ({ items, addItem, updateQuantity, removeItem, clearCart, subtotal, count, keyOf }),
    [items, subtotal, count]
  );

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};
